import type { HealthMapEdge, HealthMapNode } from "../../shared/types";
import { mockHealthMapEdges, mockHealthMapNodes } from "../mocks/healthMap";
import { getRequired, getWithFallback } from "./apiClient";

export interface HealthMapData {
  nodes: HealthMapNode[];
  edges: HealthMapEdge[];
}

export function getHealthMap(options: { realDataOnly?: boolean } = {}): Promise<HealthMapData> {
  if (options.realDataOnly) {
    return getRequired<HealthMapData>("/health-map").then((data) => normalizeHealthMapData(data, false));
  }

  return getWithFallback("/health-map", () => getMockHealthMap()).then((data) => normalizeHealthMapData(data, true));
}

function getMockHealthMap(): HealthMapData {
  return {
    nodes: mockHealthMapNodes,
    edges: mockHealthMapEdges
  };
}

function normalizeHealthMapData(data: HealthMapData, useMockFallback: boolean): HealthMapData {
  return {
    nodes: Array.isArray(data.nodes) ? data.nodes : useMockFallback ? mockHealthMapNodes : [],
    edges: Array.isArray(data.edges) ? data.edges : useMockFallback ? mockHealthMapEdges : []
  };
}
